import UploadIcon from '@mui/icons-material/Upload'
import { Alert, Divider, Drawer, IconButton } from '@mui/material'
import { Box } from '@mui/system'
import CustomGrid from 'common/components/CustomGrid'
import UserCard from 'common/components/UserCard'
import PersonalDocCard from 'features/documentos/components/PersonalDocCard'
import useFetchArbol from 'features/documentos/hooks/useFetchArbol'
import useFetchLevelDocs from 'features/documentos/hooks/useFetchLevelDocs'
import BotonSolicitudInterna from 'features/solicitudes/components/BotonSolicitudInterna'
import Icon from 'icons/Icons'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import CorporateTreeSkeleton from '../components/CorporateTreeSkeleton'
import PersonalDocTree from '../components/PersonalDocTree'

const DocPersonal = ({ forcedLevel }) => {
  const location = useLocation()
  const [user] = useState(location?.state?.user ?? null)
  const [userData, _] = useState({
    user: location?.state?.user ?? null,
    surname: location?.state?.surname ?? null,
    name: location?.state?.name ?? null,
    image: location?.state?.image ?? null,
  })
  const [selectedNode, setSelectedNode] = useState(forcedLevel ?? null)
  const [open, setOpen] = useState(false)
  const { response: tree, loading: loadingTree, error } = useFetchArbol(user)

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const { response: responseDocs, loading } = useFetchLevelDocs(selectedNode, user)

  return error ? (
    <Alert severity="error">
      Se ha producido un error en la consulta de datos. Por favor, inténtelo de nuevo más tarde
    </Alert>
  ) : (
    <Box sx={{ height: '100%' }}>
      {user ? <UserCard datos={userData} /> : null}
      <Box
        sx={{
          width: '100%',
          display: {
            xs: 'flex',
            md: 'none',
          },
          alignItems: 'center',
          gap: 1,
          mb: 1,
        }}
      >
        <IconButton onClick={toggleDrawer(true)} aria-label="Expander arbol">
          <Icon icon="fi-rr-menu-burger" />
        </IconButton>
        <BotonSolicitudInterna
          titulo="Subir Documento"
          id_solicitud_pe="PERDC"
          buttonProps={{
            sx: {
              transition: '.3s',
              textAlign: 'center',
              width: '100%',
            },
          }}
          buttonStartIcon={<UploadIcon />}
        />
        <Drawer open={open} onClose={toggleDrawer(false)}>
          <Box sx={{ minWidth: '300px', maxWidth: '400px' }}>
            <PersonalDocTree
              tree={tree}
              onNodeSelected={(nodeLevel) => {
                setSelectedNode(nodeLevel)
              }}
            />
          </Box>
        </Drawer>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, height: '100%' }}>
        {loadingTree ? (
          <CorporateTreeSkeleton />
        ) : (
          <Box sx={{ display: { xs: 'none', md: 'block' }, minWidth: '350px' }}>
            <BotonSolicitudInterna
              titulo="Subir Documento"
              id_solicitud_pe="PERDC"
              buttonProps={{
                sx: {
                  transition: '.3s',
                  textAlign: 'center',
                  width: {
                    xs: '100%',
                  },
                },
              }}
              buttonStartIcon={<UploadIcon />}
            />
            <PersonalDocTree
              tree={tree}
              onNodeSelected={(nodeLevel) => setSelectedNode(nodeLevel)}
            />
          </Box>
        )}
        <Divider
          sx={{ display: { xs: 'none', md: 'initial' } }}
          orientation="vertical"
          variant="middle"
          flexItem
        />
        <Box sx={{ width: '100%' }}>
          <CustomGrid
            showInternalSearch={false}
            gridProps={{ spacing: 2 }}
            gridItemsProps={{ size: { xs: 12, md: 4, lg: 3 } }}
            dataSource={responseDocs}
            loading={loading}
            CardLayout={({ data }) => {
              return <PersonalDocCard document={data} />
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default DocPersonal
